module.exports = __webpack_public_path__ + "static/media/vtex5.43f097d6.png";